import React, { useState, useEffect } from 'react';
import { withAccount } from '@/business-components/operator/account-context';
import { currencyFormat } from '@/pages/agency/utils/format';
import { ADVERTISE_EXPERIENCE, BUSINESS_BASE, DELIVERY_AREA } from '@/constants/Constants';

const LeadReplenish = (props) => {
  const {
    detail,
  } = props;

  const [info, setInfo] = useState({});

  const getCount = (max, min, unit) => {
    if (isNaN(max) || isNaN(min) || max === undefined || min === undefined || max === null || min === null) {
      return ''
    }
    if (max === min) {
      return `${min} ${unit}`
    }
    return `${min}-${max} ${unit}`
  };

  useEffect(() => {
    setInfo(detail.leadExtensionData || {})
  }, []);
  return (
    <div className="CustomerPanel">
      <h2 style={{position: 'relative'}}>
        线索补充
        {(detail.leadPloyLayerType === 'LEAD_PLOY_LAYER_LA' || detail.lead?.leadPloyLayerType === 'LEAD_PLOY_LAYER_LA') && <div title="根据补充信息，系统判断该线索为潜在LA，供参考" style={{position: 'absolute', padding: '0 4px', left: '81px', top: '-2px', border: '2px solid #5589cc', fontSize: '16px', color: '#5589cc', cursor: 'pointer'}}>潜在LA</div>}
      </h2>
      <dl>
        <dt>门店数量：</dt><dd>{getCount(info.maxStoreCnt, info.minStoreCnt, '家')}</dd>
        <dt>月销售总额：</dt><dd>{getCount(info.maxMonthTotalSales / 100, info.minMonthTotalSales / 100, '元')}</dd>
        <dt>客单价：</dt><dd>{getCount(info.maxCustomerPrice / 100, info.minCustomerPrice / 100, '元')}</dd>
        <dt>推广经验：</dt><dd>{info.advertiseExperience?.map(item => ADVERTISE_EXPERIENCE[item]).join(',')}</dd>
        <dt>广告推广预算：</dt><dd>{getCount(info.maxAdvertiseBudget / 100, info.minAdvertiseBudget / 100, '元')}</dd>
        <dt>竞品日消耗：</dt><dd>{getCount(info.maxDailyConsume / 100, info.minDailyConsume / 100, '元')}</dd>
        <dt>电商基本情况：</dt><dd>{info.businessBase?.map(item => BUSINESS_BASE[item]).join(',')}</dd>
        <dt>投融资：</dt><dd>{info.isFinancing === undefined ? '' : (info.isFinancing ? '是' : '否')}</dd>
        <dt>投放区域：</dt><dd>{info.deliveryArea?.map(item => DELIVERY_AREA[item]).join(',')}</dd>
      </dl>
    </div>
  )
}

export default withAccount(LeadReplenish)
